import { useEffect, useRef, useState, useCallback } from 'react';
// import { useStore } from "@hmpu/powerups.store";
import type { GetPageId } from '@hmpu/powerups.config.page.provider';
import { useTranslation } from '@hmpu/powerups.intl.hooks.use-translation';
import { usePageConfig } from '@hmpu/powerups.config.page.provider';

export function getDisabledPageIDs(
  pageNamesArray: string[],
  getPageId: GetPageId
) {
  // console.log('getDisabledPageIDs', pageNamesArray);
  return pageNamesArray
    .map((pageName: string) => getPageId(pageName))
    .filter((pageId: number | null) => pageId !== null);
}

const usePauseScreenDisabled = () => {
  const { __t } = useTranslation();

  const { currentPage, getPageId } = usePageConfig();

  const disabledPageIdsRef = useRef(
    getDisabledPageIDs(__t('disablePauseScreenOn', 'PAUSE_MENU'), getPageId)
  );

  const checkPage = useCallback(
    (pageID: number) => disabledPageIdsRef.current.indexOf(pageID),
    []
  );

  const [pauseScreenDisabled, setPauseScreenDisabled] = useState(() =>
    checkPage(currentPage)
  );

  useEffect(() => {
    setPauseScreenDisabled(disabledPageIdsRef.current.indexOf(currentPage));
  }, [currentPage]);

  return {
    pauseScreenDisabled,
  };
};

usePauseScreenDisabled.whyDidYouRender = true;

export { usePauseScreenDisabled };
